import { Injectable } from '@angular/core';
import { UploadFileManuallyService } from '../../core/services/upload-file-manually/upload-file-manually.service';
import { HttpSoap } from '../../core/services/http-soap.service';
import { environment } from '../../../environments/environment';
import { SoapRequestService } from './soap/soap-request.service';
import { HttpRequestHandler } from '../../core/models/http-model';
import { HttpService } from '../../core/services/http.service';
import { XmlFormatSettingService } from '../../core/services/xml-format-setting/xml-format-setting.service';
import { String } from 'typescript-string-operations';
import { LoadPeriodTableService } from '../../core/services/load-period-table/load-period-table.service';
import { ValuesListService } from '../../core/services/admin/values-list.service';
import { ProcessExtractionService } from '../../core/services/process-extraction/process-extraction.service';
import { IOption } from 'ng-select';
import * as xml2js from 'xml2js';
import { DocumentService } from '../../core/services/document/document.service';
import { AutomaticDataGenerationService } from '../../core/services/automatic-data-generation/automatic-data-generation.service';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { ReceptionAdvancedService } from '../../core/services/reception-advanced/reception-advanced.service';

var Base64 = require('js-base64').Base64;



const HEADERS = {};

@Injectable()
export class GeneralService {

  static ENV: any = environment;

  constructor(
    private soap: HttpSoap,
    private soapRequestService: SoapRequestService,
    private httpService: HttpService,
    private xmlFormatSettingService: XmlFormatSettingService,
    private valuesListService: ValuesListService,
    private loadPeriodsService: LoadPeriodTableService,
    private processExtractionService: ProcessExtractionService,
    private uploadFileManuallyService: UploadFileManuallyService,
    private documentService: DocumentService,
    private automaticDateGeneration: AutomaticDataGenerationService,
    private httpClient : HttpClient,
    private receptionAdvancedService: ReceptionAdvancedService,
  ) {
    HEADERS['Content-Type'] = 'application/json';
  }

  public runReportRequest(item: any = 'ALL'): Promise<any[]> {
    const listBooks = [];
    const listEntity = [];
    const listProvider = [];
    const p = new Promise<any>((resolve, reject) => {
      this.soap.post(
        `${GeneralService.ENV.environment.URL_FUSION}/xmlpserver/services/v2/ReportService`,
        'runReportRequest',
        String.Format(this.soapRequestService.findByName('RUNREPORTRQUEST'), { item: item }),
        {
          headers: { 'Content-Type': 'text/html' },
          success: (res: any) => {
            console.log('res', res);
            for (const data of res) {
              if (data.LOV_NAME[0] === 'LEDGERS_LOV') {
                listBooks.push({ id: data['CODE'][0], name: data['NAME'][0] });
              }
              if (data.LOV_NAME[0] === 'LEGAL_ENTITY_LOV') {
                listEntity.push({ id: data['CODE'][0], name: data['NAME'][0] });
              }
              if (data.LOV_NAME[0] === 'SUPPLIERS_RS_LOV') {
                listProvider.push({ id: data['CODE'][0], name: data['NAME'][0] });
              }
            }
            resolve(
              {
                listBooks: listBooks,
                listEntity: listEntity,
                listProvider: listProvider
              }
            );
          }, error: (err) => {
            reject(err);
          }
        });
    });
    return p;
  }

  public runReport(xml: string, item: any): Promise<any[]> {
    const p = new Promise<any>((resolve, reject) => {
      this.soap.postXml(
        `${GeneralService.ENV.environment.URL_FUSION}/xmlpserver/services/v2/ReportService`,
        'runReportRequest',
        String.Format(this.soapRequestService.findByName(xml), item),
        {
          headers: { 'Content-Type': 'text/html' },
          success: (res: any) => {
            resolve(res);
          },
          error: (err: any) => {
            resolve(null);
          }
        }
      );
    });
    return p;
  }

  // public runReportRequestBD(): Promise<any[]> {
  //   let listBooks: any = [];
  //   let listEntity: any = [];
  //   const listProvider = [{ id: 1, name: "PROVEEDOR 1" }];
  //   const p = new Promise<any>(async (resolve, reject) => {
  //     listBooks = await new Promise((resolve, reject) => {
  //       this.httpService.get(GeneralService.ENV.API.get_ledger, {
  //         success: res => {
  //           console.log("get_ledger res -> ", res);
  //           if (res.status == 0) {
  //             let books = [];
  //             for (const item of res.data) {
  //               books.push({ id: item.code, name: item.name });
  //             }
  //             resolve(books);
  //           }
  //         },
  //         error: err => {
  //           console.log("GeneralService.runReportRequest get_ledger error -> ", err);
  //           resolve([]);
  //         },
  //         always: () => { },
  //         includeToken: false
  //       });
  //     });

  //     listEntity = await new Promise((resolve, reject) => {
  //       this.httpService.get(GeneralService.ENV.API.get_legal_entity, {
  //         success: res => {
  //           console.log("get_legal_entity res -> ", res);
  //           if (res.status == 0) {
  //             let entity = [];
  //             for (const item of res.data) {
  //               entity.push({ id: item.code, name: item.name });
  //             }
  //             resolve(entity);
  //           }
  //         },
  //         error: err => {
  //           console.log("GeneralService.runReportRequest get_legal_entity error -> ", err);
  //           resolve([]);
  //         },
  //         always: () => { },
  //         includeToken: false
  //       })
  //     });
  //     resolve(
  //       {
  //         listBooks: listBooks,
  //         listEntity: listEntity,
  //         listProvider: listProvider
  //       }
  //     );
  //   });
  //   return p;
  // }

  public getBooks(): Promise<any[]> {
    const listBooks = [];
    const p = new Promise<any>((resolve, reject) => {
      this.soap.post(`${GeneralService.ENV.environment.URL_FUSION}/xmlpserver/services/v2/ReportService`,
        'runReportRequest',
        String.Format(this.soapRequestService.findByName('RUNREPORTRQUEST'), { item: 'LEDGERS_LOV' }),
        {
          headers: { 'Content-Type': 'text/html' },
          success: (res: any) => {

            for (const data of res) {
              if (data.LOV_NAME[0] === 'LEDGERS_LOV') {
                listBooks.push({ id: data['CODE'][0], name: data['NAME'][0] });
              }
            }
            resolve(listBooks);
          },
          error: (e) => {
            resolve(listBooks);
          }
        }
      );
    });
    return p;
  }

  public getEntities(): Promise<any[]> {
    const listTemp = [];
    const p = new Promise<any>((resolve, reject) => {
      this.soap.post(`${GeneralService.ENV.environment.URL_FUSION}/xmlpserver/services/v2/ReportService`,
        'runReportRequest',
        String.Format(this.soapRequestService.findByName('RUNREPORTRQUEST'), { item: 'LEGAL_ENTITY_LOV' }),
        {
          headers: { 'Content-Type': 'text/html' },
          success: (res: any) => {

            for (const data of res) {
              if (data.LOV_NAME[0] === 'LEGAL_ENTITY_LOV') {
                listTemp.push({ id: data['CODE'][0], name: data['NAME'][0] });
              }
            }
            resolve(listTemp);
          },
          error: (e) => {
            resolve(listTemp);
          }
        }
      );
    });
    return p;
  }

  public getPeriodsByBook(book: string): Promise<any[]> {
    let listTemp = [];
    const p = new Promise<any>((resolve, reject) => {
      this.loadPeriodsService.getPeriodsByBook({ book }, {
        headers: { 'Content-Type': 'application/json' },
        success: (periods) => {
          if (periods.status === 0) {
            listTemp = periods.data.map(
              (item) => {
                return {
                  id: `${item.id}${this.zfill(item.number, 2)}`,
                  name: item.name,
                  data: item
                };
              }
            );
          }
          resolve(listTemp);
        },
        error: (e) => {
          resolve(listTemp);
        }
      });
    });
    return p;
  }

  public getPeriodsByBook2(book: string): Promise<any[]> {
    let listTemp = [];
    const p = new Promise<any>((resolve, reject) => {
      this.loadPeriodsService.getPeriodsByBook({ book }, {
        headers: { 'Content-Type': 'application/json' },
        success: (periods) => {
          if (periods.status === 0) {
            listTemp = periods.data.map(
              (item) => {
                return {
                  id: `${item.id}|${this.zfill(item.number, 2)}`,
                  name: item.name,
                  data: item
                };
              }
            );
          }
          resolve(listTemp);
        },
        error: (e) => {
          resolve(listTemp);
        }
      });
    });
    return p;
  }

  private zfill(number, width) {
    const numberOutput = Math.abs(number); /* Valor absoluto del número */
    const length = number.toString().length; /* Largo del número */
    const zero = '0'; /* String de cero */
    if (width <= length) {
      if (number < 0) {
        return ('-' + numberOutput.toString());
      } else {
        return numberOutput.toString();
      }
    } else {
      if (number < 0) {
        return ('-' + (zero.repeat(width - length)) + numberOutput.toString());
      } else {
        return ((zero.repeat(width - length)) + numberOutput.toString());
      }
    }
  }



  public getPrintColunms(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_COL_PRINT' }, {
        success: (resp) => {
          if (resp.status === 0) {
            listaTemp = resp.data.map(
              (item) => {
                return {
                  id: item.lookup_code,
                  name: item.description,
                  item
                };
              }
            );
          }
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getDataType(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_COL_TYPE' }, {
        success: (resp) => {
          if (resp.status === 0) {
            listaTemp = resp.data.map(
              (item) => {
                return {
                  id: item.lookup_code,
                  name: item.description,
                  item
                };
              }
            );
          }
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getLedger(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.xmlFormatSettingService.getDataLedger({
        success: (resp) => {
          listaTemp = resp.data;
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getLegalEntity(book_id): Promise<any[]> {

    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.httpService.post(GeneralService.ENV.environment.API.get_legal_entity, {book_id: book_id}, {
        success: res => {
          if (res.status === 0) {
            listaTemp = res.data;
            resolve(listaTemp);
          }
        },
        error: err => {
          resolve(listaTemp);
        },
        always: () => { },
        includeToken: false
      });
    });
  }

  public getLiterals(year): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.httpService.get(`${GeneralService.ENV.environment.API.get_literals}/${year}`, {
        success: res => {
          if (res.status === 0) {
            listaTemp = res.data;
            resolve(listaTemp);
          }
        },
        error: err => {
          resolve(listaTemp);
        },
        always: () => { },
        includeToken: false
      });
    });
  }

  public getFormats(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_NUM_FORMAT' }, {
        success: (resp) => {
          if (resp.status === 0) {
            listaTemp = resp.data.map(
              (item) => {
                return {
                  id: item.lookup_code,
                  name: item.lookup_code,
                  description: item.description
                };
              }
            );
          }
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getDetailActtribute(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_DET_ATTRIBUTE' }, {
        success: (resp) => {
          listaTemp = resp.data.map(
            (item) => {
              return {
                id: item.meaning,
                name: item.meaning,
                item
              };
            }
          );
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getItemSOAP(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.xmlFormatSettingService.getDataItemSOAP(null, {
        success: (resp) => {
          listaTemp = resp;
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }
  public getItemMode(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.xmlFormatSettingService.getDataItemMode(null, {
        success: (resp) => {
          listaTemp = resp;
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getMonths(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(GeneralService.ENV.environment.API.get_months, httpRequesthandler);
  }


  public getcity(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_city, httpRequesthandler);
  }

  public getCountry(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_country, httpRequesthandler);
  }

  public getYear(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_year, httpRequesthandler);
  }

  public getActivity(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_activity, httpRequesthandler);
  }

  public getPeriodsCoding(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(GeneralService.ENV.environment.API.get_periods_coding, data, httpRequesthandler);
  }

  public getDocumentType(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_document_type, httpRequesthandler);
  }

  public getNature(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_nature, httpRequesthandler);
  }

  public getStatus(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_status, httpRequesthandler);
  }

  public getCurrency(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_currency, httpRequesthandler);
  }

  public getProcessId(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.get(GeneralService.ENV.environment.API.get_process, httpRequesthandler);
  }

  // Departamentos por codigo de ciudad
  public consultState(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
    this.httpService.post(GeneralService.ENV.environment.API.consult_state, data, httpRequesthandler);
  }

  // public getSequence(httpRequesthandler: HttpRequestHandler): void {
  //   httpRequesthandler.headers = HEADERS['Content-Type'] = 'application/json';
  //   this.httpService.get(GeneralService.ENV.API.get_sequence,  httpRequesthandler);
  // }
  //uploadFileManuallyService

  public getSequence(): Promise<any[]> {
    let sequence: number;
    return new Promise<any>((resolve, reject) => {
      this.uploadFileManuallyService.getSequence({
        success: (resp: any) => {
          if (resp.status === 0) {
            sequence = parseInt(resp.data);
            resolve(sequence);
          } else {
            reject(resp);
          }
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  public dataLoaded(processId: any): Promise<any[]> {
    return new Promise<any>((resolve, reject) => {
      this.httpService.get(`${UploadFileManuallyService.ENV.environment.API.get_data_loaded}/${processId}`, {
        success: res => {
          if (res.status === 0) {
            resolve(res);
          }
        },
        error: err => {
          reject(err);
        },
        always: () => { },
        includeToken: false
      });
    });
  }

  public getEntitiesDOEQ(idBook): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.httpService.post(GeneralService.ENV.environment.API.get_legal_entity, {book_id: idBook}, {
        success: res => {
          if (res.status === 0) {
            listaTemp = res.data;
            resolve(listaTemp);
          }
        },
        error: err => {
          resolve(listaTemp);
        },
        always: () => { },
        includeToken: false
      });
    });
  }

  public getLedgerDOEQ(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.documentService.getDataLedger({
        success: (resp) => {
          listaTemp = resp.data;
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getListFileName(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.documentService.getListFileName({
        success: (resp) => {
          listaTemp = resp.data.map(
            (item) => {
              return {
                id: item.file_name,
                name: item.file_name
              };
            }
          );
          resolve(listaTemp);
        },
        error: (err) => {
          reject(listaTemp);
        }
      });
    });
  }

  public getProviderDOEQ(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.documentService.getProviders({
        success: (resp) => {
          listaTemp = resp.data.map(
            (item) => {
              return {
                id: item.code,
                name: item.proveedor,
                item
              };
            }
          );
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getDateResolutionDOEQ(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.documentService.getLookupValueDOEQ({
        p_lookup_type: 'PARAM_DOEQ_RESOLUCION',
        p_lookup_code: "FECHA_INI_RES",
        p_language: 'ESA',
        p_opcion: '1',
      }, {
        success: (resp) => {
          listaTemp = resp.data.map(
            (item) => {
              return {
                id: item.lookup_code,
                name: item.descripcion,
              };
            }
          );
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getProccess(): Promise<any> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.httpService.get('assets/data/proccess.json', {
        success: (proccess) => {
          listaTemp = proccess;
          resolve(listaTemp);
        },
        error: (e) => {
          resolve(listaTemp);
        },
        always: () => { },
        includeToken: false
      });

    });
  }

  public getYearByLedger(ledger): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.httpService.get(`${GeneralService.ENV.environment.API.year_by_ledger}/${ledger}`, {
        success: res => {
          if (res.status === 0) {
            listaTemp = res.data;
            resolve(listaTemp);
          }
        },
        error: err => {
          resolve(listaTemp);
        },
        always: () => { },
        includeToken: false
      });
    });
  }

  public getTaskId(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(GeneralService.ENV.environment.API.get_task_id, data, httpRequesthandler);
  }

  public getJournalYear(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(GeneralService.ENV.environment.API.f_get_journal_year, data, httpRequesthandler);
  }

  public getExistNits(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(GeneralService.ENV.environment.API.get_exist_nits, data, httpRequesthandler);
  }

  public getSchema(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.loadPeriodsService.getSchema({
        success: (resp) => {
          listaTemp = resp.data.map(
            (item: any) => {
              return {
                id: item.schema_name,
                name: item.schema_name,
                item
              };
            },
            (error: any) => {
              reject(error);
            }
          );
          resolve(listaTemp);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  public getTables(data: any): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.loadPeriodsService.getTables(
        data,
        {
          success: (resp) => {
            listaTemp = resp.data.map(
              (item: any) => {
                return {
                  id: item.table_name,
                  name: item.table_name,
                  item
                };
              },
              (error: any) => {
                reject(error);
              }
            );
            resolve(listaTemp);
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }


  public xmlToJson(xml): Promise<any> {

    const p = new Promise((resolve, reject) => {
      xml2js.parseString(xml, (err, result) => {
        if (err) {
          reject(err);
        }
        resolve(result);
      });
    });

    return p;
  }

  public getProcessIdDOEQ(): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.getProcessId({
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp.data);
          } else {
            reject(0);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(0);
        },
        headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0' },
      });
    });
    return p;
  }

  public setProcessDOEQ(json: any ): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.proccessSave(json, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });
    return p;
  }

  public updtaeProcessDOEQ(json: any ): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.updateProccess(json, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });
    return p;
  }

  public getListProccessDOEQ(json: any ): Promise<any> {
    const p = new Promise((resolve, reject) => {
      let listTemp = [];
      this.documentService.getListProccess(json, {
        success: (resp) => {

          if (resp.status === 0) {
            listTemp = resp.data.map(
              (item) => {
                const listTemp1 = [];
                let log_process: any;
                try {
                  log_process = eval(item.log_process);
                } catch (e) {
                  console.log('e', e);
                  listTemp1.push(item.log_process);

                }

                return {
                  creation_date: item.creation_date,
                  id_job1: item.id_job1,
                  log_process: (listTemp1.length > 0) ? listTemp1 : log_process,
                  process_id: item.process_id,
                  status: item.status,
                  user_id: item.user_id,
                };
              }
            );
            resolve(listTemp);
          } else {
            reject(listTemp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });
    return p;
  }

  public getListProccessDOEQP(state: string): Promise<any> {
    const p = new Promise((resolve, reject) => {
      let listTemp = [];
      this.documentService.getListProccesP(state,{
        success: (resp) => {
          if (resp.status === 0) {
            listTemp = resp.data.map(
              (item) => {
                return {
                  id: item.process_id,
                  name: item.process_id,
                  ledger: item.ledger,
                  entidad_legal: item.entidad_legal,
                  proveedor: item.proveedor,
                  fecha_desde: item.fecha_desde,
                  fecha_hasta: item.fecha_hasta,
                  documento: item.documento,
                  file_name: item.file_name
                };
              }
            );
            resolve(listTemp);
          } else {
            reject(listTemp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });
    return p;
  }

  public getFileName(filename: string): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.getFileName({filename: filename}, {
        success: (resp) => {
          if (resp.status === 0){
            resolve(resp.filename);
          } else{
            reject(null);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });

    return p;
  }

  public automaticFileUpload(json: any): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.automaticFileUpload(json, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });

    return p;
  }

  public automaticGeneration(json: any): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.automaticGeneration(json, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });

    return p;
  }

  public automaticGenerationDat(json: any): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.automaticGenerationDat(json, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });

    return p;
  }

  public revokeTask(id: any): Promise<any> {
    const p = new Promise((resolve, reject) => {
      this.documentService.revokeTask(id, {
        success: (resp) => {
          if (resp.status === 0) {
            resolve(resp);
          } else {
            reject(resp);
          }
        },
        error: (e) => {
          console.log('Error => ', e);
          reject(null);
        }
      });
    });

    return p;
  }

  public getLineType(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_CONFIG_TYPE' }, {
        success: (resp) => {
          if (resp.status === 0) {
            listaTemp = resp.data.map(
              (item) => {
                return {
                  id: item.meaning,
                  name: item.description,
                  item
                };
              }
            );
          }
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public getSources(): Promise<any[]> {
    let listaTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.valuesListService.getLookupsValues({ lookup_type: 'LOV_SOURCES' }, {
        success: (resp) => {
          if (resp.status === 0) {
            listaTemp = resp.data.map(
              (item) => {
                return {
                  id: "'"+item.meaning+"'",
                  name: item.description,
                  item
                };
              }
            );
          }
          resolve(listaTemp);
        },
        error: (err) => {
          resolve(listaTemp);
        }
      });
    });
  }

  public generateBulkFile(data : any, httpRequesthandler : HttpRequestHandler){
    
    let url = GeneralService.ENV.environment.API.generate_bulk_file;
    this.httpClient.post(url, data, { responseType: 'blob' }).subscribe(
      blob => {
        httpRequesthandler.success(blob);
      }
    );

  }


  public getLogo(url : string, httpHandler : HttpRequestHandler){ 
    
    this.httpClient.get(url, { responseType: 'blob' }).subscribe(
      blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (event: any) => {
          httpHandler.success(event.target.result);
        };
      }
    );
  }

  public generic_excel_report(rows_data : any[], name_file : string, url_logo : string, tittle : string, params : any[], columns_name : string[] ){

    this.getLogo( url_logo,{
      success : img_b64 => {  
    
        let pay_load = {
          process : 'generic_excel_report',
          data : {
            rows : rows_data, 
            name_file : name_file,
            title : tittle,
            params : params,
            image : img_b64,
            headers : columns_name
          }
        }
    
        this.generateBulkFile(pay_load, {
          success : resp => {
            const blob = new  Blob([resp], 
                                    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            FileSaver.saveAs(blob, `${name_file}_${new Date().getTime()}.xlsx`);
            
          },
          error : err =>{
            console.log(err);
          }
        }); 
      }
    });
  }

  public getSuppliers(): Promise<any[]> {
    let listTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.receptionAdvancedService.getSuppliers({
        success: (resp) => {
          if (resp.status === 0) {
            listTemp = resp.data.map(
              (item) => {
                return {
                  id: item.proveedor,
                  name: item.proveedor,
                  item
                };
              }
            );
          }
          resolve(listTemp);
        },
        error: (err) => {
          resolve(listTemp);
        }
      });
    });
  }

  public getOrdenInvoice(): Promise<any[]> {
    let listTemp: any[] = [];
    return new Promise<any>((resolve, reject) => {
      this.receptionAdvancedService.getOrdenInvoice({
        success: (resp) => {
          if (resp.status === 0) {
            listTemp = resp.data;
          }
          resolve(listTemp);
        },
        error: (err) => {
          resolve(listTemp);
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/general.service.ts